import { defineStore } from 'pinia'

const usePromotionStore = defineStore('promotion', {
  state: () => ({
    // add initial state here
  }),
  actions: {
    // add actions here
  },
})

export default usePromotionStore
